module.exports = __webpack_public_path__ + "img/RichIdeas.2576c15b.png";